import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

const SearchSadIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <path
      d="M8.38265 6.01578L7.83074 5.46387L7.27344 6.0212L7.82535 6.57311L8.38265 6.01578Z"
      fill="currentColor"
    />
    <path
      d="M6.29914 8.09879L5.74723 7.54688L5.19531 8.09879L5.74723 8.6507L6.29914 8.09879Z"
      fill="currentColor"
    />
    <path
      d="M6.98881 9.51378C6.69303 10.0116 6.44771 10.5887 6.25293 11.2453L6.6804 11.4238C6.92568 10.8178 7.19804 10.2858 7.49743 9.82761C7.80045 9.37311 8.14133 8.95648 8.52011 8.57769C8.89886 8.19894 9.31549 7.85804 9.77003 7.55505C10.2281 7.25562 10.7602 6.9833 11.3662 6.73798L11.1877 6.31055C10.5275 6.50893 9.94858 6.75603 9.45077 7.05182C8.95297 7.34761 8.49304 7.70656 8.07099 8.12861C7.64894 8.55066 7.28821 9.01237 6.98881 9.51378Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.029 8.01449C15.029 9.83679 14.3341 11.4968 13.1949 12.744L14.9354 14.4845C15.2909 14.3147 15.7297 14.377 16.0242 14.6715L22.7198 21.3671C23.0934 21.7407 23.0934 22.3463 22.7198 22.7198C22.3463 23.0934 21.7407 23.0934 21.3671 22.7198L14.6715 16.0242C14.377 15.7297 14.3147 15.2909 14.4845 14.9354L12.744 13.1949C11.4968 14.3341 9.83679 15.029 8.01449 15.029C4.1405 15.029 1 11.8885 1 8.01449C1 4.1405 4.1405 1 8.01449 1C11.8885 1 15.029 4.1405 15.029 8.01449ZM14.3913 8.01449C14.3913 11.5363 11.5363 14.3913 8.01449 14.3913C4.49268 14.3913 1.63768 11.5363 1.63768 8.01449C1.63768 4.49268 4.49268 1.63768 8.01449 1.63768C11.5363 1.63768 14.3913 4.49268 14.3913 8.01449Z"
      fill="currentColor"
    />{" "}
  </IconBase>
);

export default SearchSadIcon;
